export const magicSdkBucket = 'https://duioy2gg741z7.cloudfront.net';

export function magicRendererBucket(env){
    return `${magicSdkBucket}/MagicRenderer/${env}`;
}

export function libSugarUrl(env){
    return `${magicRendererBucket(env)}/libSugar_wasm_v1.1.js`;
}

export function thumbGenUrl(env){
    return `${magicSdkBucket}/thumbGenSDK/${env === "prod" ? "prod" : "stage"}/MgThumbGenerator.js`;
}

export function mappingFileURL(env){
    return `https://dks0nmzcvbck3.cloudfront.net/v3/${env === 'prod' ? 'prod' : 'pre-prod'}/configs/sugar_map.json`;
}

export function getSugarV1Params(env) {
    return {
        host: 'https://dks0nmzcvbck3.cloudfront.net',
        bucket: '/v3',
        env: env === "prod" ? env : "pre-prod"
    }
}

export function productsServiceURL(env){
    return `https://products${env !== 'prod' ? `-${env}` : ''}.photoccino.com`;
}

export function getLayoutsUrl(env, force=false){
    return `${productsServiceURL(env)}/v3/assets/getLayouts${force ? `?force=true` : ''}`;
}

export function getSurfacesUrl(env, force=false){
    return `${productsServiceURL(env)}/v3/assets/getSurfaces${force ? `?force=true` : ''}`;
}

export function assetsCDN(env){
    if(env !== "prod" && env !== "stage") return `${productsServiceURL(env)}/v3/assets`;
    return `https://static${env !== 'prod' ? `-${env}` : ''}.photoccino.com`;
}

export function saveToDynamoUrl(env){
    return 'https://magicapi' + (env !== "prod" ? '-' + env : "") + '.photoccino.com/project';
}
